module.exports = __webpack_public_path__ + "static/media/Relative-Bold-Web.d29d122c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Bold-Web.woff
// module id = 744
// module chunks = 0